import { BaseEntity } from "../common/baseEntity";

export class CBP3461 extends BaseEntity<string> {
    public OrderId: number;
    public Name: string;
    public Created: Date;
    public Updated: Date;
    /*Header Information*/
    public PortOfEntry: DocumentProperty = new DocumentProperty();
    public BondType: DocumentProperty<number> = new DocumentProperty(); // TODO to enum
    public ImporterNumberType: DocumentProperty<number> = new DocumentProperty(); // TODO to enum
    public ImporterNumber: DocumentProperty = new DocumentProperty();
    public ImporterNameAndAddress: DocumentProperty = new DocumentProperty();
    public EntryNumber: DocumentProperty = new DocumentProperty();
    public BondValue: DocumentProperty<number> = new DocumentProperty();
    public EntryValue: DocumentProperty<number> = new DocumentProperty();
    public Ces: DocumentProperty = new DocumentProperty();
    public EntryType: DocumentProperty = new DocumentProperty();
    public OriginationWhseEntryNumber: DocumentProperty = new DocumentProperty();
    public PortOfUnLanding: DocumentProperty = new DocumentProperty();
    public LocationOfGoods: DocumentProperty = new DocumentProperty();
    public ModeOfTransportation: DocumentProperty<number> = new DocumentProperty(); // TODO to enum
    public SuretyCode: DocumentProperty = new DocumentProperty();
    public GONumber: DocumentProperty = new DocumentProperty();
    public ConveyanceName: DocumentProperty = new DocumentProperty();

    /*Header Reference Information*/
    public ReferenceIdCode: DocumentProperty = new DocumentProperty();
    public ReferenceIdNumber: DocumentProperty = new DocumentProperty();

    /*Header Parties Start*/
    public HeaderPartyType: DocumentProperty<number> = new DocumentProperty(); // TODO to enum
    public HeaderPartyNameAndAddress: DocumentProperty = new DocumentProperty();
    public HeaderIDType: DocumentProperty<number> = new DocumentProperty(); // TODO to enum
    //why number?
    public HeaderID: DocumentProperty<number> = new DocumentProperty();

    /*Certification start*/
    public CertificationSignatureOfApplicant: DocumentProperty = new DocumentProperty();
    public PhoneNumber: DocumentProperty = new DocumentProperty();
    public CertificationDate: DocumentProperty = new DocumentProperty();

    public IsOtherAgencyActionRequired: DocumentProperty<boolean> = new DocumentProperty();
    public OtherAgencyActionNamely: DocumentProperty = new DocumentProperty();
    public IsCBPExaminationRequired: DocumentProperty<boolean> = new DocumentProperty();
    public IsEntryRejected: DocumentProperty<boolean> = new DocumentProperty();
    public EntryRejectedExplanation: DocumentProperty = new DocumentProperty();

    public BrokerOrOtherGOVT: DocumentProperty = new DocumentProperty();
    public DeliverySignature: DocumentProperty = new DocumentProperty();
    public DeliveryDate: DocumentProperty = new DocumentProperty();

    /*Line info start*/
    public LineHtsCode1: DocumentProperty = new DocumentProperty();
    public LineValue1: DocumentProperty<number> = new DocumentProperty();
    public LineHtsCode2: DocumentProperty = new DocumentProperty();
    public LineValue2: DocumentProperty<number> = new DocumentProperty();

    public ZoneStatus: DocumentProperty<number> = new DocumentProperty(); // TODO to enum
    public HtcCommercialDescType: DocumentProperty<number> = new DocumentProperty();// TODO to enum
    public HtcCommercialDescValue: DocumentProperty = new DocumentProperty();

    public LineItemQuantity: DocumentProperty<number> = new DocumentProperty();
    public FtzFilingDate: DocumentProperty = new DocumentProperty();

    public LinePartyType: DocumentProperty<number> = new DocumentProperty();// TODO to enum
    public CountryOfOrigin: DocumentProperty = new DocumentProperty();
    public LineNameAddress: DocumentProperty = new DocumentProperty();
    public LineIdNumberType: DocumentProperty<number> = new DocumentProperty();// TODO to enum
    public LineIdNumberValue: DocumentProperty = new DocumentProperty();
    /*Line info end*/

    /*Bill of landing information*/
    public NonAmsOrSplitBill: DocumentProperty<number> = new DocumentProperty();

    public FirstBillOfLanding: BillOfLanding = new BillOfLanding();
    public SecondBillOfLanding: BillOfLanding = new BillOfLanding();

    public VoyageOrFltOrTrip: DocumentProperty = new DocumentProperty();
    public Conveyance: DocumentProperty = new DocumentProperty();

    public ArrivalDate: DocumentProperty = new DocumentProperty();

}

export class DocumentProperty<T = string> {
    public Value: T;
    public IsValid: boolean = true;
    public Errors: Array<string> = [];
}

export class BillOfLanding {
    public BolTypeInBond: DocumentProperty<boolean> = new DocumentProperty();
    public BolTypeMaster: DocumentProperty<boolean> = new DocumentProperty();
    public BolTypeHouse: DocumentProperty<boolean> = new DocumentProperty();
    public BolTypeRegularOrSimple: DocumentProperty<boolean> = new DocumentProperty();
    public ScacOrCarrierId: DocumentProperty = new DocumentProperty();
    public InBondNumber: DocumentProperty = new DocumentProperty();
    public BolNumber: DocumentProperty = new DocumentProperty();
    public Quantity: DocumentProperty<number> = new DocumentProperty();
    public UnitOfMeasure: DocumentProperty = new DocumentProperty();
}


// WEBPACK FOOTER //
// ./app/objects/documents/CBP3461.ts